(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aathi-kundali-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('AathiKundaliDialog');
  if (!dialog || !dialog.showModal) return;
  let opener;
  let previousOverflow;
  const seenKey = "aathi-kundali-visit-v2";
  const remember = () => { try { sessionStorage.setItem(seenKey, "1"); } catch (_) {} };
  const openInvitation = (trigger) => {
    if (dialog.open) return;
    opener = trigger || document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    dialog.showModal();
    document.documentElement.style.overflow = "hidden";
    remember();
    dialog.querySelector("[data-kundali-close]").focus();
  };
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-kundali-open]');
    if (!trigger || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    openInvitation(trigger);
  });
  dialog.querySelector('[data-kundali-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow || '';
    if (opener && opener.isConnected) opener.focus();
  });
  // Never interrupt visitors already using the finder, cart or theme editor.
  const excluded = /\/(?:cart|checkout|checkouts|account)(?:\/|$)/.test(location.pathname) || location.pathname.includes('/pages/kundali-product-finder');
  if (!excluded && !(window.Shopify && window.Shopify.designMode)) {
    setTimeout(() => {
      try { if (sessionStorage.getItem(seenKey)) return; } catch (_) {}
      if (document.visibilityState !== 'visible' || document.querySelector('dialog[open]') || /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName)) return;
      openInvitation();
    }, 2000);
  }
})();
  } catch(e) { console.error(e); }
})();

})();
